'use client';
import dynamic from 'next/dynamic';
import { FC } from 'react';

import ICON_SIZE, { ICON_COLOR } from '@/constant/icon-size-color';

const IconLoading = () => <div style={{ width: '1em', height: '1em' }} />;

const iconMap = {
  SlLayers: dynamic(() => import('~/images/icons/SlLayers'), { 
    loading: () => <IconLoading />,
    ssr: true 
  }),
  PiHeart: dynamic(() => import('~/images/icons/piHeart'), { 
    loading: () => <IconLoading />,
    ssr: true 
  }),
  CiDiscount1: dynamic(() => import('~/images/icons/CiDiscount1'), { 
    loading: () => <IconLoading />,
    ssr: true 
  }),
  CiPlug1: dynamic(() => import('~/images/icons/CiPlug1'), { 
    loading: () => <IconLoading />,
    ssr: true 
  }),
  IoIosCodeWorking: dynamic(() => import('~/images/icons/IoIosCodeWorking'), { 
    loading: () => <IconLoading />,
    ssr: true 
  }),
  PiFileHtmlLight: dynamic(() => import('~/images/icons/PiFileHtmlLight'), { 
    loading: () => <IconLoading />,
    ssr: true 
  })
};

interface DynamicComponentProps {
  iconName: keyof typeof iconMap | string;
  size?: number;
  color?: string;
}

const DynamicComponent: FC<DynamicComponentProps> = ({
  iconName,
  size = ICON_SIZE.lg,
  color = ICON_COLOR.gray
}) => {
  const Icon = iconMap[iconName as keyof typeof iconMap];

  if (!Icon) {
    return <div>Component not found</div>;
  }

  return <Icon size={size} color={color} />;
};

export default DynamicComponent;
